module.exports = __webpack_public_path__ + "img/logo.5ba70c91.svg";